<template>
  <UFormField :label="label" :name="name" class="text-xs w-full flex-1">
    <UButtonGroup class="w-full">
      <div v-if="loading" class="py-1.5"><USkeleton class="h-4 w-full"/></div>
      <USelectMenu
        v-else
        option-attribute="label"
        value-attribute="value"
        value-key="value"
        class="text-xs w-full"
        color="neutral"
        v-model="model"
        :items="items"
        :placeholder="placeholder"
        :loading="loading"
        :disabled="disabled"
        :ui="{
          item: 'text-xs',
          label: 'text-xs',
          content: 'text-xs z-[10000]'
        }"
      />
      <UButton
        v-if="model != '-1'"
        icon="i-lucide-circle-x"
        variant="subtle"
        class="cursor-pointer " color="neutral" 
        :disabled="model === clearValue"
        @click="model = clearValue"
        :title="$t('common.tooltip.clear')"
        style="color:red"
      />
    </UButtonGroup>  
  </UFormField>
</template>
<script lang="ts" setup>
  const model = defineModel<string>({ default: '-1' })
  const props = defineProps<{
    label?: string
    name?: string
    items: any[]
    placeholder?: string
    loading?: boolean
    disabled?: boolean
    clearValue?: string
    clearable?: boolean
  }>()

  const clearValue = computed(() => props.clearValue ?? '-1')
</script>